// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import{getAuth} from "firebase/auth";
import { getStorage } from "firebase/storage"; // Import storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB3Pvxi-d38g2mIS4ZhYc2FV28y9xTwVM4",
  authDomain: "smartjettech-b1c44.firebaseapp.com",
  projectId: "smartjettech-b1c44",
  storageBucket: "smartjettech-b1c44.appspot.com",
  messagingSenderId: "936760798336",
  appId: "1:936760798336:web:7c5aa31a1e5979c45f4a65"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const fireDB= getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app); 
export {fireDB,auth, storage};